/**
 * @throws error with the supplied message, if the condition is not true.
 *
 * Can for example be used like a type guard in TypeScript.
 */
export function assert(condition, msg) {
    if (!condition) {
        throw new Error(msg);
    }
}
/**
 * @throws error with the supplied message, if the value === undefined.
 *
 * Can be used like a type guard in TypeScript.
 */
export function assertDefined(value, msg) {
    if (value === undefined) {
        throw new Error(msg);
    }
}
